import React, { useState, useEffect } from "react";
import { Card, Col, DatePicker, Row, Select, Tabs } from "antd";
import {
  getDashboardCount,
  getDashboardOutstanding,
  getDashboardTopOutstandingCustomer,
  getDashboardValue,
} from "../../redux/Dashboard/DashboardActions";
import moment from 'moment';
import { useSelector } from "react-redux";
import LeadsCard from "./CardsNew/leadsCard";
import SalesInvoiceCard from "./CardsNew/salesInvoiceCard";
import EnquiryCard from "./CardsNew/enquiryCard";
import CustomerComplaintCard from "./CardsNew/customerComplaintCard";
import {
  getCollectionVsTarget,
  getCollectionCustomerwise,
  getCollectionAgingwiseWithoutTax,
  getOSOD,
  getOSODCustomerwise,
  getOSODExecutivewise,
  getOnAccountExecutivewise,
  getOnAccountCustomerwise,
  getODAgewise,
  getODCustomerwise,
  getSalesNewProduct,
  getSalesNewProductReport,
  getSOCategorywise,
  getSOCustomerwise,
  getSOExecutivewise,
  getSalesCustomerwise,
  getSalesCategorywise,
  getSalesProductCategorywise,
  getSalesStatewise,
  getSalesCustomerCategorywise,
  getReviewTargetvsActualSales,
  getReviewExecutiveWiseOSODPercentage,
  getReviewIncentiveTargetvsActualCollection,
  getReviewSalesOrderPending,
  getReviewCategoryWiseSales,
  getReviewCustomerWiseSalesQtyValue,
  getReviewDistributorTargetvsActual,
  getReviewCategoryWiseSalesValue,
} from "../../redux/DashboardManager/DashboardManagerActions";

import DailyReviewTab from "./Cards/DailyReviewTab";
import OSODTab from "./Cards/OSODTab";
import CollectionTab from "./Cards/CollectionTab";
import SalesOrderPendingTab from "./Cards/SalesOrderPendingTab";
import NewProductSalesTab from "./Cards/NewProductSalesTab";
import SalesTrendTab from "./Cards/SalesTrendTab";
import { getNotifyConfigList } from "../../redux/Settings/SettingsActions";

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const fromDate = moment().startOf('month'); // 1st January of current year as Moment object
const toDate = moment(); // Today as Moment object
export default function Dashbpard() {

  const [dates, setDates] = useState([fromDate, toDate]);
  const {
    DashboardCount,
    DashboardOutstanding,
    DashboardTopOutstandingCustomer,
    DashboardValue,
  } = useSelector((state) => state.Dashboard);

  const {
    collectionVsTarget,
    collectionCustomerwise,
    collectionAgingwiseWOTax,
    osod,
    osodCustomerwise,
    osodExecutivewise,
    onAccountExecutivewise,
    onAccountCustomerwise,
    odAgewise,
    odCustomerwise,
    salesNewProduct,
    salesNewProductReport,
    soCategorywise,
    soCustomerwise,
    soExecutivewise,
    soPendingReport,
    salesCustomerwise,
    salesCategorywise,
    salesProductCategorywise,
    salesStatewise,
    salesCustomerCategorywise,
    // --- Daily Review Dashboard ---
    reviewTargetVsActualSales,
    reviewExecutiveOsodPercentage,
    reviewIncentiveTargetVsActual,
    reviewSalesOrderPending,
    reviewCategoryWiseSales,
    reviewCustomerWiseSalesQtyValue,
    reviewDistributorTargetVsActual,
    reviewCategoryWiseSalesValue,
  } = useSelector((state) => state.DashboardManager || {});

  const role = localStorage.getItem("Team") || "Admin";
  const user = localStorage.getItem("userCode") || "";

  const Usercode = localStorage.getItem("userCode") || "";
  useEffect(() => {
    getDashboardValue(Usercode);
    getDashboardCount(Usercode);
    getDashboardOutstanding(Usercode);
    getDashboardTopOutstandingCustomer(Usercode);
    getNotifyConfigList()
  }, []);

  useEffect(() => {
    // Actions that require date range
    getCollectionVsTarget(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getCollectionCustomerwise(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getCollectionAgingwiseWithoutTax(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getSalesNewProduct(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getSalesNewProductReport(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));

    // Actions that do NOT require date range
    getOSOD(role, user);
    getOSODCustomerwise(role, user);
    getOSODExecutivewise(role, user);
    getOnAccountExecutivewise(role, user);
    getOnAccountCustomerwise(role, user);
    getODAgewise(role, user);
    getODCustomerwise(role, user);
    getSOCategorywise(role, user);
    getSOCustomerwise(role, user);
    getSOExecutivewise(role, user);
    getSalesCustomerwise(role, user);
    getSalesCategorywise(role, user);
    getSalesProductCategorywise(role, user);
    getSalesStatewise(role, user);
    getSalesCustomerCategorywise(role, user);

    // --- Daily Review Dashboard actions ---
    getReviewTargetvsActualSales(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getReviewExecutiveWiseOSODPercentage(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getReviewIncentiveTargetvsActualCollection(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getReviewSalesOrderPending(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getReviewCategoryWiseSales(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getReviewCustomerWiseSalesQtyValue(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getReviewDistributorTargetvsActual(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
    getReviewCategoryWiseSalesValue(role, user, moment(dates[0]).format("YYYY-MM-DD"), moment(dates[1]).format("YYYY-MM-DD"));
  }, [role, user, dates]);  // Add `dates` to the dependency array


  //Total Value Cards (MTD/YTD)
  const valueData = DashboardValue || [];
  const lead = valueData.find((item) => item.Type === "Lead") || {};
  const enquiry = valueData.find((item) => item.Type === "Enquiry") || {};
  const flexiQuote = valueData.find((item) => item.Type === "FlexiQuote") || {};
  const quotation = valueData.find((item) => item.Type === "Quotation") || {};
  const salesOrder = valueData.find((item) => item.Type === "SaleOrder") || {};
  const salesQuote = valueData.find((item) => item.Type === "SalesQuote") || {};
  const salesInvoice =
    valueData.find((item) => item.Type === "SalesInvoice") || {};
  //Status Count
  //Lead
  const leadCountData = DashboardCount || [];
  const leadCount = leadCountData.find((item) => item.Lead) || {};
  const leadStatusCounts = leadCount.Lead || [];
  //Market
  const marketCountData = DashboardCount || [];
  const marketCount = marketCountData.find((item) => item.Market) || {};
  const marketStatusCounts = marketCount.Market || [];
  //factory
  const factoryCountData = DashboardCount || [];
  const factoryCount = factoryCountData.find((item) => item.factory) || {};
  const factoryStatusCounts = factoryCount.factory || [];
  //Flexi
  const flexiCountData = DashboardCount || [];
  const flexiCount = flexiCountData.find((item) => item.Flexi) || {};
  const flexiStatusCounts = flexiCount.Flexi || [];
  //Quotation
  const quotationCountData = DashboardCount || [];
  const quotationCount =
    quotationCountData.find((item) => item.Quotation) || {};
  const quotationStatusCounts = quotationCount.Quotation || [];
  //SaleOrder
  const saleOrderCountData = DashboardCount || [];
  const saleOrderCount =
    saleOrderCountData.find((item) => item.SaleOrder) || {};
  const saleOrderStatusCounts = saleOrderCount.SaleOrder || [];
  //CustomerComplaint
  const customerComplaintCountData = DashboardCount || [];
  const customerComplaintCount =
    customerComplaintCountData.find((item) => item.CustomerComplaint) || {};
  const customerComplaintStatusCounts =
    customerComplaintCount.CustomerComplaint || [];

  //Outstanding (Aging Buckets)
  const outstanding = DashboardOutstanding?.[0] || {};
  const agingData = [
    { name: "0-30", value: outstanding.D0toD30 || 0 },
    { name: "31-60", value: outstanding.D31toD60 || 0 },
    { name: "61-90", value: outstanding.D61toD90 || 0 },
    { name: "91-120", value: outstanding.D91toD120 || 0 },
    { name: "120+", value: outstanding.D120Above || 0 },
    { name: "MTD", value: outstanding.OSMTD || 0 },
    { name: "YTD", value: outstanding.OSYTD || 0 },
    { name: "OS", value: outstanding.TotalOustanding || 0 },
  ];
  //Top Outstanding Customer
  const topCustomers = DashboardTopOutstandingCustomer || [];

  const handleDateChange = (dates) => {
    if (dates) {
      const [startDate, endDate] = dates;
      localStorage.setItem("fromDate", startDate.toISOString());
      localStorage.setItem("toDate", endDate.toISOString());
      setDates([startDate, endDate]); // Update local state with Moment objects
    }
  };

  return (
    <>
      <div className="dashboard-page">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div className="dashboard-header">
            <p className="dashboard-title">🚀 Dashboard</p>
            <p className="dashboard-subtitle">Let’s see the current stats.</p>
          </div>
          <div className="date-picker-wrapper" style={{ margin: "10px" }}>
            <RangePicker
              value={dates}
              onChange={handleDateChange}
              style={{ marginBottom: "16px", float: "right" }}
            />
          </div>
        </div>
        <Tabs
          animated
          type="card"
          defaultActiveKey="market"
          className="premium-tabs"
          tabBarGutter={12}
        >
          <TabPane tab="🎯 Marketing" key="market">
            <Row gutter={[24, 24]} style={{ marginTop: 16 }}>
              <Col span={24}>
                <Row>
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    lg={8}
                    xl={8}
                    className="hp-overflow-hidden hp-px-24"
                  >
                    <LeadsCard
                      data={leadStatusCounts}
                      label={"Lead"}
                      data2={lead}
                    />
                  </Col>
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    lg={8}
                    xl={8}
                    className="hp-overflow-hidden hp-px-24"
                  >
                    <LeadsCard
                      data={flexiStatusCounts}
                      label={"Flexi"}
                      data2={flexiQuote}
                    />
                  </Col>
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    lg={8}
                    xl={8}
                    className="hp-overflow-hidden hp-px-24"
                  >
                    <LeadsCard
                      data={quotationStatusCounts}
                      label={"Quotation"}
                      data2={quotation}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="hp-mt-24" gutter={[24, 24]} style={{ marginBottom: 16 }}>
              <Col xs={24} md={16} className="hp-overflow-hidden hp-px-24">
                <EnquiryCard
                  marketData={marketStatusCounts}
                  factoryData={factoryStatusCounts}
                  label={"Enquiry"}
                  data2={enquiry}
                />
              </Col>
              <Col xs={24} md={8} className="hp-overflow-hidden hp-px-24">
                <CustomerComplaintCard
                  data={customerComplaintStatusCounts}
                  label={"Customer Complaint"}
                />
              </Col>
            </Row>
          </TabPane>

          <TabPane tab="📦 Order / Collection" key="sales">
            <Row gutter={[24, 24]} style={{ padding: 16 }}>
              <Col xs={24} md={16} className="hp-overflow-hidden">
                <SalesInvoiceCard
                  topCustomers={topCustomers}
                  agingData={agingData}
                />
              </Col>
              <Col xs={24} md={8} className="hp-overflow-hidden">
                <LeadsCard
                  data={saleOrderStatusCounts}
                  label={"Sale Order"}
                  data2={salesOrder}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tab="📊 Daily Review" key="dailyreview">
            <DailyReviewTab
              targetVsActual={reviewTargetVsActualSales}
              executiveOsOd={reviewExecutiveOsodPercentage}
              incentiveTargetVsActual={reviewIncentiveTargetVsActual}
              salesOrderPending={reviewSalesOrderPending}
              categoryWiseSales={reviewCategoryWiseSales}
              customerWiseSales={reviewCustomerWiseSalesQtyValue}
              distributorTargetVsActual={reviewDistributorTargetVsActual}
              categoryWiseSalesValue={reviewCategoryWiseSalesValue}
            />
          </TabPane>
          <TabPane tab="📉 OS/OD" key="osod">
            <OSODTab
              osod={osod}
              osodCustomerwise={osodCustomerwise}
              osodExecutivewise={osodExecutivewise}
              onAccountExecutivewise={onAccountExecutivewise}
              onAccountCustomerwise={onAccountCustomerwise}
              odAgewise={odAgewise}
              odCustomerwise={odCustomerwise}
              summary={{
                OS_AMT: osod?.[0]?.OS_AMT,
                OD_AMT: osod?.[0]?.OD_AMT,
                PERCENT: osod?.[0]?.OD_Percentage,
              }}
            />
          </TabPane>
          <TabPane tab="💰 Collection" key="collection">
            <CollectionTab
              collectionVsTarget={collectionVsTarget}
              collectionCustomerwise={collectionCustomerwise}
              collectionAgingwiseWOTax={collectionAgingwiseWOTax}
            />
          </TabPane>
          <TabPane tab="📦 Sales Order Pending" key="salesorderpending">
            <SalesOrderPendingTab
              soCategorywise={soCategorywise}
              soCustomerwise={soCustomerwise}
              soExecutivewise={soExecutivewise}
              soPendingReport={soPendingReport}
            />
          </TabPane>
          <TabPane tab="🆕 New Product Sales" key="newproductsales">
            <NewProductSalesTab
              salesNewProduct={salesNewProduct}
              salesNewProductReport={salesNewProductReport}
            />
          </TabPane>
          <TabPane tab="📈 Sales Trend" key="salestrend">
            <SalesTrendTab
              salesCustomerwise={salesCustomerwise}
              soCategorywise={soCategorywise}
              soCustomerwise={soCustomerwise}
              salesCategorywise={salesCategorywise}
              salesProductCategorywise={salesProductCategorywise}
              salesStatewise={salesStatewise}
              salesCustomerCategorywise={salesCustomerCategorywise}
            //salesYearwise = {}
            //salesExecutivewise = {}
            //salesExecutivewiseYearMonth = {}
            />
          </TabPane>
        </Tabs>
      </div >

      {/* 
      <p className="h4 hp-mb-6">🚀 Dashboard</p>
      <p className="h5 hp-mx-24">Let's see the current stats.</p>
      <Divider className="hp-mb-12 hp-mt-6" />
      <Tabs animated type="card" defaultActiveKey="market" className="hp-mb-18">
      </Tabs> */}
    </>
  );
}
